/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicareComponentEstimate } from './MedicareComponentEstimate';
import {
    MedicareComponentEstimateFromJSON,
    MedicareComponentEstimateFromJSONTyped,
    MedicareComponentEstimateToJSON,
    MedicareComponentEstimateToJSONTyped,
} from './MedicareComponentEstimate';

/**
 * 
 * @export
 * @interface MedicareEstimates
 */
export interface MedicareEstimates {
    /**
     * 
     */
    estimates: Array<MedicareComponentEstimate>;
    /**
     * 
     */
    unadjusted_total: number;
    /**
     * 
     */
    adjusted_total: number;
    /**
     * 
     */
    hipps_code?: string | null;
    /**
     * 
     */
    days_1_3_rate?: number | null;
    /**
     * 
     */
    days_4_100_rate?: number | null;
}

/**
 * Check if a given object implements the MedicareEstimates interface.
 */
export function instanceOfMedicareEstimates(value: object): value is MedicareEstimates {
    if (!('estimates' in value) || value['estimates'] === undefined) return false;
    if (!('unadjusted_total' in value) || value['unadjusted_total'] === undefined) return false;
    if (!('adjusted_total' in value) || value['adjusted_total'] === undefined) return false;
    return true;
}

export function MedicareEstimatesFromJSON(json: any): MedicareEstimates {
    return MedicareEstimatesFromJSONTyped(json, false);
}

export function MedicareEstimatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareEstimates {
    if (json == null) {
        return json;
    }
    return {
        
        'estimates': ((json['estimates'] as Array<any>).map(MedicareComponentEstimateFromJSON)),
        'unadjusted_total': json['unadjusted_total'],
        'adjusted_total': json['adjusted_total'],
        'hipps_code': json['hipps_code'] === undefined ? undefined : json['hipps_code'] === null ? null : json['hipps_code'],
        'days_1_3_rate': json['days_1_3_rate'] === undefined ? undefined : json['days_1_3_rate'] === null ? null : json['days_1_3_rate'],
        'days_4_100_rate': json['days_4_100_rate'] === undefined ? undefined : json['days_4_100_rate'] === null ? null : json['days_4_100_rate'],
    };
}

export function MedicareEstimatesToJSON(json: any): MedicareEstimates {
    return MedicareEstimatesToJSONTyped(json, false);
}

export function MedicareEstimatesToJSONTyped(value?: MedicareEstimates | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'estimates': ((value['estimates'] as Array<any>).map(MedicareComponentEstimateToJSON)),
        'unadjusted_total': value['unadjusted_total'],
        'adjusted_total': value['adjusted_total'],
        'hipps_code': value['hipps_code'],
        'days_1_3_rate': value['days_1_3_rate'],
        'days_4_100_rate': value['days_4_100_rate'],
    };
}

